import illustrations from '@/assets/img/png/ilustrations';
import { TIlustrationContent } from '..';
import { APP_NAME } from '@/constants/stringVars';

const howMyOmniaCanHelpContent: TIlustrationContent = {
  title: `How ${APP_NAME} can help?`,
  infoItems: [
    {
      title: 'Wellness Report',
      description: 'We will ask you some questions about how you feel.',
      iconPath: illustrations.wellnessReport,
    },
    {
      title: 'Useful Insights',
      description: 'After you finish your intake we will show you a report of your current state of wellness.',
      iconPath: illustrations.headWithCog,
    },
    {
      title: 'Peer Support Team',
      description: 'Get support and support others because we are all stronger in community',
      iconPath: illustrations.headToHead,
    },
    {
      title: 'Vetted Providers',
      description: 'Culturally competent 3rd party providers that deliver high quality care and growth support.',
      iconPath: illustrations.nurse,
    },
  ],
};

export default howMyOmniaCanHelpContent;
